import baseModel from './index';
import UtilityService from "../providers/utilityService";

class FetchRefinerModel extends baseModel {

    // =============
    // CONSTRUCTOR
    // =============

    constructor(state) {
        super(state);
        this.initState(state);
    }

    // ===============
    // CLASS METHODS
    // set default properties here
    // ===============

    static defaultState() {
        return {
            homePageRefinerData: [],
            resultPageRefinerData: []
        };
    }


    // =====================
    // INTERFACING METHODS
    // init all the sates
    // =====================

    initState(state) {
        this.state = Object.assign(this.constructor.defaultState(), state);
        this.constructor.prototype.getPageLevelFilter = this.constructor.getPageLevelFilter;
        this.constructor.prototype.buildCombinedFilterData = this.constructor.buildCombinedFilterData;
        this.constructor.prototype.buildRefinerBasedOnSearch = this.constructor.buildRefinerBasedOnSearch;
        this.constructor.prototype.buildFlatRefinerBasedOnSearch = this.constructor.buildFlatRefinerBasedOnSearch;
        this.constructor.prototype.saveSelectedRefiners = this.constructor.saveSelectedRefiners;
        this.constructor.prototype.buildRefinementValue = this.constructor.buildRefinementValue;
    }


    // // =====================
    // // create refiner array based on confgi data, termstore data
    // // return page level refiner
    // // =====================

    static getPageLevelFilter(configData, termStoreData) {
        const combinedFilterData = { homePage: [], resultPage: [] };
        const pageLevels = { homePage: [], resultPage: [] };
        const pageLevelKeys = Object.keys(pageLevels);
        if (configData && Object.keys(configData).length > 0 && termStoreData && Object.keys(termStoreData).length > 0) {
            pageLevels.homePage = configData.homePage && UtilityService.nonRefCopyObject(configData.homePage.refiners);
            pageLevels.resultPage = configData.resultsPage && UtilityService.nonRefCopyObject(configData.resultsPage.refiners);
            pageLevelKeys.forEach((pLevel) => {
                combinedFilterData[pLevel] = UtilityService.nonRefCopyObject(pageLevels[pLevel]);
                pageLevels[pLevel].forEach((item, index) => {
                    if (termStoreData && termStoreData[item.displayProperty] && termStoreData[item.displayProperty].length > 0) {
                        combinedFilterData[pLevel][index].refinerValues = termStoreData[item.displayProperty];
                    }
                    if (item.displayProperty === "owstaxIdEYKDGeoAccess") {
                        combinedFilterData[pLevel][index].refinerValues = termStoreData.owstaxIdEYKDGeoScope;
                    }
                });
            });
        }
        return combinedFilterData;
    }

    // // =====================
    // // create refiner refiner array based on confgi data, termstore data and search results
    // // return Refiner array
    // // =====================

    static buildCombinedFilterData(pageLevelRefiners,searchResultData, appliedRefinerArray) {
        const filterItems = [];
        this.state.selectedRefiners = [];

        if (pageLevelRefiners && Array.isArray(pageLevelRefiners)) {
            pageLevelRefiners.forEach((item) => {
                const filterItemObject = UtilityService.nonRefCopyObject(item);
                // this is a taxonomy filter
                if(item.refinerValues){
                    filterItemObject.refinerValues = this.buildRefinerBasedOnSearch(item.refinerValues,searchResultData,appliedRefinerArray, item.displayProperty, item.dataType, item.displayText);
                }
                else{
                    filterItemObject.refinerValues = this.buildFlatRefinerBasedOnSearch(item,searchResultData, appliedRefinerArray, item.displayText);
                }

                if (filterItemObject.refinerValues && filterItemObject.refinerValues.length > 0) {
                    filterItems.push(filterItemObject);
                }
            });
        }
        return filterItems;
    }


    // // =====================
    // // function to save selected refiner array
    // // =====================

    static saveSelectedRefiners(matchingRefiner,dataType,displayText,description){        
        let appliedMatchKey;
        this.state.selectedRefiners.find((appliedFilter, appiedKey) => {
            if (matchingRefiner.RefinerName === appliedFilter.managedProperty) {
                appliedMatchKey = appiedKey;
                return true;
            }
            return false;
        });
        if(appliedMatchKey>=0){
            this.state.selectedRefiners[appliedMatchKey].values.push({
                id:matchingRefiner.id,
                value:matchingRefiner.value
            });
        }
        else {
            this.state.selectedRefiners.push({
                "managedProperty": matchingRefiner.RefinerName,
                "dataType":dataType,
                "displayText": displayText,
                "description":description,
                "values": [{
                    id:matchingRefiner.id,
                    value:matchingRefiner.value
                }]
            });
        }
    }


     // // =====================
    // // function to build refiner value for comparison
    // // =====================

    static buildRefinementValue(refinerData){ 
        let refinerValue = ""; 
        if(refinerData && refinerData.id && refinerData.value){
            refinerValue = `L0|#0${refinerData.id}|${refinerData.value}`;
        }
        return refinerValue;
    }


    // // =====================
    // // Recursive function to build refiner array for taxonomy filters
    // // return Refiner array
    // // =====================


    static buildRefinerBasedOnSearch(filterData, searchResultData, appliedRefinerArray, refinerName, dataType, displayText, pathOfTermId='') {
        const filterItems = [];
        let isChecked = false;
        if (filterData && Array.isArray(filterData) && searchResultData && Array.isArray(searchResultData) && refinerName) {
            filterData.forEach((item) => {
                const filterItem = UtilityService.nonRefCopyObject(item);
                if(item.id){
                    filterItem.pathOfTermId = pathOfTermId?`${ pathOfTermId  };${  item.id }`:item.id;
                }
                if(item.children && item.children.length > 0){
                    filterItem.children = this.buildRefinerBasedOnSearch(item.children,searchResultData,appliedRefinerArray,refinerName, dataType, displayText, filterItem.pathOfTermId);
                }

                if (item.id) {
                    const matchingRefiner = searchResultData.find(refiner =>
                        refiner.RefinementValue && refiner.RefinementValue.includes(item.id) && refiner.RefinerName === refinerName);
                    
                    if(matchingRefiner){
                        let isCheckFound = "";
                        const matchRefinerValue = this.buildRefinementValue(item);
                        if(Array.isArray(appliedRefinerArray)){
                            isCheckFound = appliedRefinerArray.find( appliedFilter => 
                                appliedFilter.includes(matchRefinerValue) && appliedFilter.includes(refinerName))
                        }
                        isChecked = !!isCheckFound;
                        filterItems.push({...filterItem, ...matchingRefiner, isChecked});
                        if(isChecked){
                            this.saveSelectedRefiners({...filterItem, ...matchingRefiner},dataType,displayText);
                        }

                    }

                }

            });
        }

        return filterItems;
    }

    // // =====================
    // // Function to build refiner array for normal flat structure filters
    // // return Refiner array
    // // =====================

    static buildFlatRefinerBasedOnSearch(filterData, searchResultData,appliedRefinerArray,displayText){
        let matchingRefiners = [];
        const flatRefinerFilter = [];
        let isCheckFound = "";
             if(searchResultData && Array.isArray(searchResultData)){
                matchingRefiners = searchResultData.filter(refiner =>
                    refiner.RefinerName === filterData.displayProperty
                );
                if(matchingRefiners && Array.isArray(matchingRefiners)){
                    matchingRefiners.forEach( matchRef => {  
                    const matchRefinerObj =   matchRef;                        
                    matchRefinerObj.value = matchRefinerObj.RefinementValue;
                    matchRefinerObj.id = matchRefinerObj.RefinementValue;
                    matchRefinerObj.pathOfTermId = matchRefinerObj.RefinementValue;
                    isCheckFound = "";
                    if(Array.isArray(appliedRefinerArray)){
                        // eslint-disable-next-line no-useless-escape
                        isCheckFound = appliedRefinerArray.find( appliedFilter => appliedFilter.includes(`\"${UtilityService.getHexToken(matchRefinerObj.RefinementValue)}\"`) && appliedFilter.includes(matchRefinerObj.RefinerName) );
                    }
                    matchRefinerObj.isChecked = !!isCheckFound;
                    flatRefinerFilter.push(matchRefinerObj);
                    if(matchRefinerObj.isChecked){
                        this.saveSelectedRefiners(matchRefinerObj,filterData.dataType,displayText);
                    }
                });
            }
        }
        return flatRefinerFilter;
    }

}

export default FetchRefinerModel;